export const GET_EXPENSES = 'GET_EXPENSES';
export const GET_EXPENSES_ERROR = 'GET_EXPENSES_ERROR';
export const GET_EXPENSES_SUCCESS = 'GET_EXPENSES_SUCCESS';

export const GET_RECEVABLE_PAYABLE = 'GET_RECEVABLE_PAYABLE';
export const GET_RECEVABLE_PAYABLE_ERROR = 'GET_RECEVABLE_PAYABLE_ERROR';
export const GET_RECEVABLE_PAYABLE_SUCCESS = 'GET_RECEVABLE_PAYABLE_SUCCESS';

export const GET_INCOME_AND_EXPENSES_BY_MONTHS = 'GET_INCOME_AND_EXPENSES_BY_MONTHS';
export const GET_INCOME_AND_EXPENSES_BY_MONTHS_ERROR = 'GET_INCOME_AND_EXPENSES_BY_MONTHS_ERROR';
export const GET_INCOME_AND_EXPENSES_BY_MONTHS_SUCCESS = 'GET_INCOME_AND_EXPENSES_BY_MONTHS_SUCCESS';

export const GET_PROVIDENT_FUND = 'GET_PROVIDENT_FUND';
export const GET_PROVIDENT_FUND_ERROR = 'GET_PROVIDENT_FUND_ERROR';
export const GET_PROVIDENT_FUND_SUCCESS = 'GET_PROVIDENT_FUND_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Dashboard/constants.js